export default "__VITE_ASSET__CiC_5iYd__"